import { render, staticRenderFns } from "./truckStt.vue?vue&type=template&id=043e85e9&scoped=true"
import script from "./truckStt.vue?vue&type=script&lang=js"
export * from "./truckStt.vue?vue&type=script&lang=js"
import style0 from "./truckStt.vue?vue&type=style&index=0&id=043e85e9&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043e85e9",
  null
  
)

export default component.exports